import { yupResolver } from "@hookform/resolvers/yup";
import {
  Badge,
  Button,
  Card,
  Divider,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputLabel,
  OutlinedInput,
  Stack,
  Typography,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import React, { useState, useRef, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import Appbar from "../../components/Appbar";
import Body from "../../components/Body";
import Drawer from "../../components/Drawer";
import { toast } from "react-hot-toast";
import { classEditApi } from "../../store/class/classEdit";
import { classAddApi } from "../../store/class/classAdd";
import { classDetailsApi } from "../../store/class/classDetail";
const schema = yup
  .object({

    title: yup.string().required("Please Provide A category ").trim(),
  })
  .required();

export default function ClassEdit() {
  const classDetails = useSelector((state) => state?.classDetails);

  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });
  const params = useParams();
  const navigate = useNavigate();
  const classAdd = useSelector((state) => state?.classAdd);
  const classEdit = useSelector((state) => state?.classEdit);
  useEffect(() => {
    if (params.id) {
      dispatch(classDetailsApi(params.id));
    }
  }, [dispatch]);
  const handleUpdateForm = async (value) => {
    var newObj;
    if (value.title_hn === '')
      delete value.title_hn
    if (params.id) {
      newObj = { ...value, id: params.id };
      await dispatch(classEditApi(newObj));
      if (!classEdit?.loading) {
        navigate("/class-management");
      }
    } else {
      await dispatch(classAddApi(value));
      if (!classAdd?.loading) {
        navigate("/class-management");
      }
    }
  };

  useEffect(() => {
    let defalutValues = {};
    if (params.id) {
      defalutValues["title"] = classDetails?.result?.title;
      defalutValues["title_hn"] = classDetails?.result?.title_hn;
    }
    reset(defalutValues);
  }, [classDetails]);

  return (
    <>
      <Appbar />
      <Drawer />
      <Body>
        <form onSubmit={handleSubmit(handleUpdateForm)}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Card>
                <Typography>Class Details</Typography>
                <Stack spacing={2} my={2}>
                  <Divider />

                  <Stack direction="row" spacing={2}>
                    <FormControl variant="outlined" fullWidth>
                      <InputLabel htmlFor="outlined-adornment-category" shrink>
                        Title
                      </InputLabel>
                      <OutlinedInput
                        {...register("title")}
                        label="title"
                        notched
                        id="outlined-adornment-category"
                        error={errors?.title?.message}
                      />
                      <FormHelperText error>
                        {errors?.title?.message}
                      </FormHelperText>
                    </FormControl>
                    <FormControl variant="outlined" fullWidth>
                      <InputLabel htmlFor="outlined-adornment-category" shrink>
                        Title (Hindi)
                      </InputLabel>
                      <OutlinedInput
                        {...register("title_hn")}
                        label="title_hn"
                        notched
                        id="outlined-adornment-category"
                        error={errors?.title_hn?.message}
                      />
                      <FormHelperText error>
                        {errors?.title_hn?.message}
                      </FormHelperText>
                    </FormControl>

                  </Stack>
                </Stack>
              </Card>
              <Button
                type="button"
                sx={{ float: "right", mt: 2, ml: 2 }}
                variant="contained"
                onClick={() => navigate(-1)}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                sx={{ float: "right", mt: 2 }}
                variant="contained"
              >
                {params.id ? "Update" : "Create"}
              </Button>
            </Grid>
          </Grid>
        </form>
      </Body>
    </>
  );
}
